import * as BiIcons from "react-icons/bi";

export const ChevronUp = () => {
  const Icon = BiIcons.BiChevronUp as unknown as React.FC<{ size?: number }>;
  return <Icon size={16} />;
};

export const ChevronDown = () => {
  const Icon = BiIcons.BiChevronDown as unknown as React.FC<{ size?: number }>;
  return <Icon size={16} />;
};

export const SearchIcon = () => {
  const Icon = BiIcons.BiSearch as unknown as React.FC<{ size?: number }>;
  return <Icon size={20} />;
};
